export enum Timer {
    LOADING = 500,
}
